import { SubHeader, Table } from "UI_Components";
import { Button, Label, Input, Dropdown, CoreLoader, AlertMessage } from "common/components";
import SelectPickerInput from "common/components/SelectPicker";
import apiManager from "networking/baseAPIManager";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../assets/style/Responsive.css";
const AddHolidayForm = ({ setOpen, data }) => {
  const [selectCountry, setSelectCountry] = useState([]);
  const [leftSelectState, setLeftSelectState] = useState([]);
  const [rightSelectState, setRightSelectState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showMSG, setShowMSG] = useState(false);
  const [msgType, setMsgType] = useState("info");

  const [leftSelectedCountry, setLeftSelectedCountry] = useState();
  const [leftSelectedState, setLeftSelectedState] = useState();

  const [rightSelectedCountry, setRightSelectedCountry] = useState();
  const [rightSelectedState, setRightSelectedState] = useState();
  const currentYear = new Date().getFullYear();
  const [leftSelectedYear, setLeftSelectedYear] = useState(currentYear);
  const [rightSelectedYear, setRightSelectedYear] = useState(currentYear);

  const [tableData, setTableData] = useState([]);
  const [status, setStatus] = useState("pending");
  const [holidayInputs, setHolidayInputs] = useState(
    Array.from({ length: 1 }, () => ({ holiday_name: "", date: "", country: "", state: "" }))
  );

  const years = Array.from({ length: 3 }, (_, index) => currentYear + index);
  const navigate = useNavigate();

  const customHtml = (data) => {
    return <Button onClick={() => handleItemClick(data)} label="View" />;
  };

  const customHtml1 = (data) => {
    return <Button onClick={() => handleEditModal(data)} label="Edit" />;
  };

  const customHtml2 = (data) => (
    <div className="d-flex gap-3">
      {data.holiday_status === "pending" ? (
        <Button onClick={() => handleItemClick(data)} label="View" />
      ) : (
        <Button onClick={() => handleEditModal(data)} label="Edit" />
      )}
    </div>
  );
  const moment = require("moment");
  const formatDate = (date) => moment(date).format("YYYY");
  const columns = [
    { header: "Year", field: "year", customHtml: (data) => formatDate(data.year) },
    { header: "Country", field: "country" },
    {
      header: "State",
      field: "state",
    },
    {
      header: "Status",
      field: "holiday_status",
      customHtml: (data) => {
        const statusColor =
          data?.holiday_status?.toLowerCase() === "pending"
            ? "blue"
            : data?.holiday_status?.toLowerCase() === "rejected"
            ? "red"
            : "green";

        return <span style={{ color: statusColor }}>{data.holiday_status}</span>;
      },
    },
    { header: "Actions", field: "actions", btnType: "primary", customHtml: customHtml2 },
  ];

  const handleItemClick = (data) => {
    navigate(`/hrtools/attendance/holiday-list-calendar/${data._id}`);
  };

  const handleEditModal = (data) => {
    navigate(`/hrtools/attendance/holiday-list-calendar/${data._id}`);
  };

  useEffect(() => {
    setLoading(true);
    apiManager
      .country()
      .then((country) => {
        setLoading(false);
        setSelectCountry(country.data);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    if (leftSelectedCountry) {
      apiManager
        .stateByName(leftSelectedCountry)
        .then((state) => {
          setLoading(false);
          setLeftSelectState(state.data);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    }
  }, [leftSelectedCountry]);

  useEffect(() => {
    setLoading(true);
    if (rightSelectedCountry) {
      apiManager
        .stateByName(rightSelectedCountry)
        .then((state) => {
          setLoading(false);
          setRightSelectState(state.data);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    }
  }, [rightSelectedCountry]);

  const handleLeftSelectCountry = (value) => {
    setLeftSelectedCountry(value);
  };

  const handleLeftSelectState = (value) => {
    setLeftSelectedState(value);
  };

  const handleRightSelectCountry = (value) => {
    setRightSelectedCountry(value);
  };

  const handleRightSelectState = (value) => {
    setRightSelectedState(value);
  };

  const handleHolidayInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedInputs = [...holidayInputs];
    if (name === "holiday_name") {
      const regex = /^[A-Za-z \/-]*$/;
      if (!regex.test(value)) {
        return;
      }
    }
    if (name === "date") {
      const selectedDate = new Date(value);
      if (!isNaN(selectedDate.getTime())) {
        const year = leftSelectedYear;
        const month = selectedDate.getMonth() + 1;
        const day = selectedDate.getDate() + 1;
        const newDate = new Date(year, month - 1, day);
        if (!isNaN(newDate.getTime())) {
          updatedInputs[index][name] = newDate.toISOString().split("T")[0];
        } else {
          console.error("Invalid new date");
        }
      } else {
        console.error("Invalid selected date");
      }
    } else {
      updatedInputs[index][name] = value;
    }

    setHolidayInputs(updatedInputs);
  };

  const handleAddMoreHolidayInput = () => {
    if (holidayInputs.length >= 1) {
      setHolidayInputs([...holidayInputs, { holiday_name: "", date: "", country: "", state: "" }]);
    }
  };

  const handleRemoveHolidayInput = (index) => {
    if (holidayInputs.length > 1) {
      const updatedInputs = [...holidayInputs];
      updatedInputs.splice(index, 1);
      setHolidayInputs(updatedInputs);
    }
  };

  const handleLeftYearChange = (leftSelectedYear) => {
    setLeftSelectedYear(leftSelectedYear);
  };

  const handleRightYearChange = (rightSelectedYear) => {
    setRightSelectedYear(rightSelectedYear);
  };

  const handleSaveAndContinue = (event) => {
    event.preventDefault();
    setLoading(true);

    const filledHolidayInputs = holidayInputs.filter(
      (input) => input.holiday_name.trim() !== "" && input.date.trim() !== ""
    );
    const specificState = leftSelectState.find((item) => item.id == leftSelectedState);

    const yearAsNumber = parseInt(leftSelectedYear);

    const requestData = {
      country: leftSelectedCountry,
      state: leftSelectedState,
      year: yearAsNumber,

      holiday: filledHolidayInputs.map((input) => ({
        holiday_name: input.holiday_name,
        date: input.date,
      })),
    };

    apiManager
      .addbulkholiday(requestData)
      .then((res) => {
        setLoading(false);
        setMsgType("success");
        setShowMSG(res?.data?.message || "details updated successfully");
        const newHolidays = filledHolidayInputs.map((input) => ({
          date: input.date,
          country: selectCountry[leftSelectedCountry]?.id,
          state: specificState?.id,
        }));

        setTableData([...tableData, ...newHolidays]);
        setStatus("pending");
        fetchData();
        setHolidayInputs(Array.from({ length: 1 }, () => ({ holiday_name: "", date: "", country: "", state: "" })));
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        setShowMSG(error?.response?.data?.message || "failed to update");
      });
  };

  const fetchData = () => {
    const pendingParams = {
      holiday_status: "pending",
      year: rightSelectedYear ? rightSelectedYear : currentYear,
      country: rightSelectedCountry,
      state: rightSelectedState,
    };

    const rejectedParams = {
      holiday_status: "rejected",
      year: rightSelectedYear ? rightSelectedYear : currentYear,
      country: rightSelectedCountry,
      state: rightSelectedState,
    };

    const pendingPromise = apiManager.holidaylist(pendingParams);
    const rejectedPromise = apiManager.holidaylist(rejectedParams);

    Promise.all([pendingPromise, rejectedPromise])
      .then((results) => {
        const pendingHolidays = results[0].data.list;
        const rejectedHolidays = results[1].data.list;
        const mergedHolidays = [...pendingHolidays, ...rejectedHolidays];

        setTableData(mergedHolidays);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching holiday list:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [rightSelectedCountry, rightSelectedState, rightSelectedYear]);

  let dropdownData = years.map((year) => ({ label: year.toString(), value: year.toString() }));

  return (
    <>
      <div className="Container m-0 p-0">
        <AlertMessage show={showMSG} setShow={setShowMSG} type={msgType} />
        <SubHeader location={useLocation()} />
        <div className="row pt-2 m-3">
          <div className="col-lg-12 main_table p-5">
            <div className="row g-2">
              <div className="col-md-6 pb-3">
                <Button type="button" label="Back" onClick={() => navigate(`/hrtools/attendance/holiday-calendar`)} />
              </div>
            </div>
            <div className="row g-2">
              <div className="col-xxl-6 ">
                <div className="border rounded p-4" style={{ maxHeight: "640px", overflowY: "auto" }}>
                  <div className="row g-2">
                    <div className="col-xxl-6 col-xl-4 col-md-12 col-sm-12">
                      <Dropdown
                        valueKey="name"
                        parentclasses=""
                        required
                        placeholder="Select Country"
                        options={selectCountry}
                        onChange={(e) => {
                          handleLeftSelectCountry(e.target.value);
                        }}
                        value={leftSelectedCountry}
                      />
                    </div>
                    <div className="col-xxl-6 col-xl-4 col-md-12 col-sm-12">
                      <Dropdown
                        valueKey="name"
                        parentclasses=""
                        required
                        placeholder="Select State"
                        options={leftSelectState}
                        onChange={(e) => handleLeftSelectState(e.target.value)}
                        value={leftSelectedState}
                      />
                    </div>
                    <div className="col-xxl-6 col-xl-4 col-md-12 col-sm-12">
                      <SelectPickerInput
                        sidelabel="Select Year"
                        defaultselect={currentYear}
                        data={dropdownData}
                        value={leftSelectedYear}
                        valueKey={"value"}
                        onChange={handleLeftYearChange}
                      />
                    </div>
                  </div>
                  {holidayInputs.map((input, index) => (
                    <div className="d-flex justify-content-between" key={index}>
                      <span style={{ width: "50px" }}>{index + 1}</span>
                      <div className="row p-3 border rounded mb-3">
                        <Label label="Holiday Name" parentclasses="col-lg-6 col-xxl-4" />
                        <Input
                          type="text"
                          name="holiday_name"
                          inputclasses="form-controlcustom w-100"
                          parentclasses="col-lg-12 col-xxl-8"
                          value={input.holiday_name}
                          onChange={(e) => handleHolidayInputChange(index, e)}
                        />
                        <Label label="Date" parentclasses="col-lg-6 col-xxl-4 mt-4" />
                        <Input
                          type="date"
                          name="date"
                          inputclasses="form-controlcustom w-100"
                          parentclasses="col-lg-12 col-xxl-8 mt-4"
                          value={input.date}
                          onChange={(e) => {
                            handleHolidayInputChange(index, e);
                          }}
                        />
                        {index >= 1 && (
                          <div className="col-md-12">
                            <Button
                              type="button"
                              label="Remove"
                              onClick={() => handleRemoveHolidayInput(index)}
                              className="btn btn-danger mt-3"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                  <div className="d-flex gap-3 justify-content-end subheaderbackground p-2 px-4 col-md-12">
                    <Button type="button" label="Add More" onClick={handleAddMoreHolidayInput} />
                    <Button type="submit" label="Save & Continue" onClick={handleSaveAndContinue} />
                  </div>
                </div>
              </div>
              <div className="col-xxl-6 ">
                <div className="border rounded p-4">
                  <div className="row g-2">
                    <div className="col-xxl-6 col-xl-4 col-md-12 col-sm-12">
                      <Dropdown
                        valueKey="name"
                        parentclasses="col-12"
                        required
                        placeholder="Select Country"
                        options={selectCountry}
                        onChange={(e) => {
                          handleRightSelectCountry(e.target.value);
                        }}
                        value={rightSelectedCountry}
                      />
                    </div>
                    <div className="col-xxl-6 col-xl-4 col-md-12 col-sm-12">
                      <Dropdown
                        valueKey="name"
                        parentclasses=""
                        required
                        placeholder="Select State"
                        options={rightSelectState}
                        onChange={(e) => handleRightSelectState(e.target.value)}
                        value={rightSelectedState}
                      />
                    </div>
                    <div className="col-xxl-6 col-xl-4 col-md-12 col-sm-12">
                      <SelectPickerInput
                        sidelabel="Select Year"
                        defaultselect={rightSelectedYear}
                        data={dropdownData}
                        value={rightSelectedYear}
                        valueKey={"value"}
                        onChange={handleRightYearChange}
                      />
                    </div>
                  </div>
                  <div className="row p-3">
                    <Table columns={columns} btn_name="view" secondary_btn_label="Edit" Data={tableData} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CoreLoader show={loading} disableLines />
      </div>
    </>
  );
};

export default AddHolidayForm;
